import {
  dataPersonEntityId,
  DataPersonEntityId,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataPersonGetRequestDTO {
  private static validation = Validate.compile(
    DataPersonGetRequestDTO.validationSchema()
  );

  constructor(readonly data: DataPersonGetRequestDTORaw) {
    Validate.assert(DataPersonGetRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['id'],
      properties: {
        id: dataPersonEntityId,
      },
    };
  }
}

interface DataPersonGetRequestDTORaw {
  id: DataPersonEntityId;
}
